import './_loading.scss';
import VStore from "../../store";
export default function Loading() {
    const {isMobile} = VStore();

    return (<div className="loading" style={{justifyContent: isMobile ? 'space-between' : 'center'}}>
        {
            isMobile ? <div/> : ''
        }
        <img src="./assets/images/logo.svg" alt="Loading Logo"/>
        {
            isMobile ? <span>
                Lưu ý: Các chức năng chỉ được hỗ trợ đầy đủ trên thiết bị có màn hình lớn hơn 9 inch.
            </span> : ''
        }
    </div>);
}
